import { TemplateData } from './htmlTemplates';

export const gradientModernTemplate = {
  id: 'gradient-modern',
  name: '渐变现代',
  description: '现代渐变背景，适合科技和时尚内容',
  category: 'modern',
  generate: (data: TemplateData) => `
    <!DOCTYPE html>
    <html lang="zh-CN">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Cover</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .cover {
          width: 400px;
          height: 600px;
          background: linear-gradient(135deg, ${data.theme.primaryColor}20, ${data.theme.accentColor}40, #ffffff);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 40px;
          font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
          position: relative;
          overflow: hidden;
        }

        .cover::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, ${data.theme.primaryColor}10 0%, transparent 70%);
          animation: rotate 20s linear infinite;
        }

        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        .brand-logo {
          position: absolute;
          top: 30px;
          right: 30px;
          font-size: 24px;
          opacity: 0.7;
          z-index: 2;
        }

        .content {
          position: relative;
          z-index: 2;
          text-align: center;
        }

        .title {
          font-size: 48px;
          font-weight: 900;
          color: #1a1a1a;
          line-height: 1.1;
          margin-bottom: 30px;
          letter-spacing: -1px;
          text-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }

        .title-accent {
          background: linear-gradient(45deg, ${data.theme.primaryColor}, ${data.theme.accentColor});
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          position: relative;
        }

        .subtitle {
          font-size: 18px;
          color: #555555;
          line-height: 1.5;
          font-weight: 400;
          max-width: 280px;
          margin: 0 auto;
        }

        .highlight-word {
          background: ${data.theme.accentColor};
          color: white;
          padding: 2px 8px;
          border-radius: 20px;
          font-weight: 600;
          margin: 0 2px;
          box-shadow: 0 2px 8px ${data.theme.accentColor}40;
        }

        .decorative-circle {
          position: absolute;
          bottom: 60px;
          left: 50%;
          transform: translateX(-50%);
          width: 100px;
          height: 100px;
          border: 3px solid ${data.theme.primaryColor}30;
          border-radius: 50%;
          border-top-color: ${data.theme.primaryColor};
          animation: spin 3s linear infinite;
        }

        @keyframes spin {
          to { transform: translateX(-50%) rotate(360deg); }
        }
      </style>
    </head>
    <body>
      <div class="cover">
        <div class="brand-logo">${data.theme.logo}</div>
        <div class="content">
          <h1 class="title">
            ${data.title.split(' ').map((word, i) => 
              i % 2 === 0 ? `<span class="title-accent">${word}</span>` : word
            ).join(' ')}
          </h1>
          <p class="subtitle">${data.subtitle.replace(/([^\s]{3,6})/g, '<span class="highlight-word">$1</span>')}</p>
        </div>
        <div class="decorative-circle"></div>
      </div>
    </body>
    </html>
  `
};
